var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("path", {
    attrs: {
      d: "M29.03 57c-3.23 0-6.136-1.954-7.105-4.886l-15.5-41.691c-.647-2.28-.647-4.886.645-6.84C8.362 1.629 10.622.326 12.883 0h.646c3.23 0 5.813 1.954 6.782 5.211l8.719 22.475L37.426 5.21c.97-2.605 3.23-4.56 5.813-4.885C45.823 0 48.73.977 50.344 2.93c1.615 2.28 2.26 5.212.969 7.818L36.135 52.114C35.165 55.046 32.259 57 29.03 57zM13.852 4.886c-1.292 0-1.938.651-2.584 1.303-.323.651-.646 1.628-.323 2.605l15.501 41.692c.323.977 1.292 1.954 2.584 1.954s2.26-.651 2.584-1.954l15.5-41.692c.324-.977.324-1.954-.322-2.931-.646-.652-1.615-.977-2.584-.977-.969.325-1.937.977-2.26 1.954L29.03 41.691 16.112 6.84c-.323-1.303-1.291-1.954-2.26-1.954z",
      fill: "#007C84",
      "fill-rule": "nonzero",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }